import axios from 'axios';
import { FC, useCallback, useEffect, useState } from 'react';
import { FiChevronRight, FiCopy, FiX } from 'react-icons/fi';
import { IoIosArrowDropleftCircle, IoIosArrowForward } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import { clearIntervalAsync } from 'set-interval-async';
import Swal from 'sweetalert2';
import { Loading } from '../../components/Loading';
import { StyledTitle } from '../../components/StyledTitle';
import { findConsultById, updateConsult } from '../../hooks/usePayments';
import { contatoCommunix } from '../../services/contatoCommunix';
import theme from '../../styles/themes/default';
import {
  ButtonCopyPaste,
  DefaultContainer,
  DefaultContainerSummaryPix,
  DefaultDivPix,
  DefaultSpanListPix,
  DefaultTitlePix,
  DivCopyPaste,
  DivGrid,
  DivList,
  DivPixCodeNotification,
  DivPixQrCode,
  ModalPix,
  ModalPixButton,
  ModalPixContent,
  ModalPixContentTitle,
  ModalPixDetail,
  ModalPixDetailContainer,
  ModalPixDetailContainerDebt,
  ModalPixIconSuccessMessage,
  ModalPixSuccessMessage,
  PaymentSummaryPix,
  PixPaymentContainer,
  SpanQrCode,
  SpanWaitingPayment,
  TextAreaCopyPaste,
  TextSummaryPix,
  TextSummaryPixLink,
  TitleSummaryPix,
} from './style';
import {
  IAllDebts,
  InstallmentInfo,
  useBatchPayment,
} from '../../context/BatchPaymentContext';
import generatePixForBatchs from '../../services/generatePixForBatches';
import { useUser } from '../../context/UserContext';
import ModalUserContactComunix from './components/ModalUserContactComunix';
import { useContactComunixFormData } from '../../context/ContactComunixContext';
import { handleDebtsByType } from '../../utils/debtsProcessing';

const PixBatchPayment: FC = () => {
  const {
    allDebtsSelected,
    cupom,
    pix,
    handleConsultClean,
  } = useBatchPayment();

  const [pixQrCodeBase64, setPixQrCodeBase64] = useState<string>('');
  const [pixCopiaCola, setPixCopiaCola] = useState<string>('');
  const [isPixCopied, setIsPixCopied] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const { user } = useUser();
  const [modalPixSuccess, setModalPixSuccess] = useState(false);
  const [modalDetail, setShowModalDetail] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [storeData, setStoreData] = useState<any>({});

  const [licenciamentoSelected, setLicenciamentoSelected] = useState<
    IAllDebts[]
  >(handleDebtsByType('licenciamento', allDebtsSelected));
  const [dpvatSelected, setDpvatSelected] = useState<IAllDebts[]>(
    handleDebtsByType('dpvat', allDebtsSelected),
  );
  const [multasSelected, setMultasSelected] = useState<IAllDebts[]>(
    handleDebtsByType('multas', allDebtsSelected),
  );
  const [outrosSelected, setOutrosSelected] = useState<IAllDebts[]>(
    handleDebtsByType('outros', allDebtsSelected),
  );
  const [ipvaSelected, setIpvaSelected] = useState<IAllDebts[]>(
    handleDebtsByType('ipva', allDebtsSelected),
  );

  const {
    namePartner,
    cnpj: cnpjModal,
    cpf: cpfModal,
    email: emailModal,
    phone: phoneModal,
  } = useContactComunixFormData();

  const navigate = useNavigate();

  const copyTextToClipboard = useCallback(async (text: string) => {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }, []);

  useEffect(() => {
    if (!isPixCopied) return;
    const timer = setTimeout(() => {
      setIsPixCopied(false);
    }, 2500);
    return () => {
      clearTimeout(timer);
    };
  }, [isPixCopied]);

  const generateQrCode = useCallback(
    async (dataPixIs: any, consultCodeIs: any) => {
      const result = await generatePixForBatchs(dataPixIs);

      console.log('result', result);

      const { copiaCola, qrCode, sucesso } = result;

      if (sucesso) {
        findConsultById(consultCodeIs).then(async (storageConsult) => {
          if (storageConsult !== 'There is no such consult') {
            const data = {
              ...storageConsult,
              subUsuario: storageConsult.subUsuario ?? user?.sub ?? null,
              userPool: 'Cadastro',
              dataConsulta: {
                ...storageConsult?.dataConsulta,
                nome: user?.name,
              },
              email: user?.email,
              payloadCaptura: dataPixIs,
              payloadComprovante: result.data,
              subStatus: 'payment',
            };

            const updatedConsult = await updateConsult(data).catch((e) => {
              console.log('🚀 ~ file: index.tsx:1429 ~ updatedConsult ~ e', e);
              return undefined;
            });
          }
        });
      }

      setPixQrCodeBase64(qrCode);
      setPixCopiaCola(copiaCola);
      setLoading(false);

      return;
    },
    [user],
  );

  const getPix = useCallback(async () => {
    // if (!consultCode) {
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Falha ao carregar a consulta!',
    //     html: `Ocorreu um erro inesperado ao carregar os dados da consulta.`,
    //     confirmButtonColor: theme.colors.orange.primary,
    //     didClose: () => {
    //       handleConsultClean();
    //       navigate('/debts');
    //     },
    //   });
    //   return;
    // }
    // const consulta = await findConsultById(consultCode ?? 0);

    // if (consulta?.payloadCaptura) {
    //   setLoading(false);

    //   window.localStorage.setItem(
    //     'zignet:PayloadCaptura',
    //     JSON.stringify(consulta?.payloadCaptura),
    //   );
    //   window.localStorage.setItem(
    //     'zignet:PayloadComprovante',
    //     JSON.stringify(consulta?.payloadComprovante),
    //   );
    //   Swal.fire({
    //     icon: 'warning',
    //     html: `Já existe um pagamento em andamento para este veículo;`,
    //     confirmButtonColor: theme.colors.orange.primary,
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       console.log('Botão de confirmação clicado');
    //       navigate('/proof');
    //     }
    //   });

    //   return;
    // }

    // try {
    //   setLoading(true);

    //   const cpf = cpfModal || user?.document?.length === 11 ? user?.document : '';
    //   const cnpj = cnpjModal || user?.document?.length === 14 ? user?.document : '';
    //   const telefone = phoneModal || user?.phone || '';
    //   const email = emailModal || user?.email || '';
    //   const nome = namePartner || user?.name || '';

    //   const dataPix = {
    //     name: nome,
    //     cnpj,
    //     cpf,
    //     pix: pix as InstallmentInfo,
    //     cupom,
    //     email,
    //     phone: telefone,
    //     debitos: consult?.debitos,
    //     consultCode: consultCode ?? 0,
    //     sub: user?.sub ?? '',
    //     consult: consulta,
    //   };

    //   const checkContato = window.localStorage.getItem(
    //     `Zignet:Contato:${consultCode}`,
    //   );

    //   if (checkContato !== 'true') {
    //     await contatoCommunix({
    //       consulta: String(consultCode),
    //       telefone,
    //       cnpj,
    //       cpf,
    //       email,
    //       nome,
    //     })
    //       .then((response) => {
    //         if (response.data?.sucesso) {
    //           window.localStorage.setItem(
    //             `Zignet:Contato:${consultCode}`,
    //             response.sucesso,
    //           );

    //           generateQrCode(dataPix, consultCode);
    //         } else {
    //           setLoading(false);
    //           setShowContactModal(true)
    //         }
    //       })
    //       .catch((err) => {
    //         setLoading(false);
    //         console.log('GeneratePix Catch: ', { err });
    //         setShowContactModal(true)
    //       });
    //   } else {
    //     generateQrCode(dataPix, consultCode);
    //   }
    // } catch (err: any) {
    //   console.log('GeneratePix Catch: ', { err });
    //   if (err?.response?.data?.warning) {
    //     Swal.fire({
    //       icon: 'warning',
    //       html: `Valor divergente do Débito.`,
    //       confirmButtonColor: theme.colors.orange.primary,
    //     });
    //     setLoading(false);
    //     return;
    //   }

    //   setLoading(false);
    // }
  }, [
    // consult?.debitos,
    // consultCode,
    cupom,
    generateQrCode,
    handleConsultClean,
    navigate,
    pix,
    user
  ]);

  useEffect(() => {
    if (
      user &&
      pix &&
      Number(pix?.totalPrice?.toString().replace(',', '.')) > 0 &&
      pix.month > 0
    ) {
      getPix();
    }
  }, [user, pix]);

  useEffect(() => {
    const clear = async (timer: any) => await clearIntervalAsync(timer);
    const timer = setInterval(async () => {
      // if (consultCode && !modalPixSuccess) {
      //   const storageConsult = await findConsultById(consultCode);
      //   window.addEventListener('beforeunload', async () => await clear(timer));
      //   if (
      //     String(storageConsult?.status).toLowerCase() === 'aprovado' ||
      //     String(storageConsult?.status).toLowerCase() === 'liquidado'
      //   ) {
      //     if (modalDetail === true) setShowModalDetail(false);
      //     setModalPixSuccess(true);
      //     await clear(timer);
      //   }
      // }
    }, 10000);
    return () => {
      window.removeEventListener(
        'beforeunload',
        async () => await clear(timer),
      );
      clearInterval(timer);
    };
  }, [ modalDetail, modalPixSuccess]);

  useEffect(() => {
    const store = window.localStorage.getItem('zignet:PayloadCaptura');

    if (store) {
      const parsedJSON = JSON.parse(store);

      if (!parsedJSON?.[0]?.payloadCaptura) {
        return;
      }

      const {
        consultCode,
        installment,
        dpvatSelected,
        ipvaSelected,
        licenciamentoSelected,
        multasSelected,
        outrosSelected,
      } = JSON.parse(parsedJSON?.[0]?.payloadCaptura);

      if (
        consultCode &&
        installment &&
        dpvatSelected &&
        ipvaSelected &&
        licenciamentoSelected &&
        multasSelected &&
        outrosSelected
      ) {
        setStoreData({
          consultCode,
          installment,
          dpvatSelected,
          ipvaSelected,
          licenciamentoSelected,
          multasSelected,
          outrosSelected,
        });
      }

      window.localStorage.removeItem('zignet:PayloadCaptura');
    }
  }, []);

  return (
    <>
      {loading && <Loading position="fixed" />}
      {showContactModal && <ModalUserContactComunix
        setShowContactModal={setShowContactModal}
        showContactModal={showContactModal}
        getPix={getPix}
      />}
      {modalDetail && (
        <ModalPix>
          <ModalPixContent>
            <ModalPixContentTitle>Detalhes do pedido</ModalPixContentTitle>
            <ModalPixDetail>
              {ipvaSelected.length > 0 && (
                <ModalPixDetailContainer>
                  <h2>IPVA</h2>
                  {ipvaSelected.map((ipva) => (
                    <ModalPixDetailContainerDebt>
                      <p>
                        {ipva.plate} - {ipva.uf}
                      </p>
                      <p>
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(ipva.value)}
                      </p>
                    </ModalPixDetailContainerDebt>
                  ))}
                </ModalPixDetailContainer>
              )}
              {dpvatSelected.length > 0 && (
                <ModalPixDetailContainer>
                  <h2>DPVAT</h2>
                  {dpvatSelected.map((dpvat) => (
                    <ModalPixDetailContainerDebt>
                      <p>
                        {dpvat.plate} - {dpvat.uf}
                      </p>
                      <p>
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(dpvat.value)}
                      </p>
                    </ModalPixDetailContainerDebt>
                  ))}
                </ModalPixDetailContainer>
              )}
              {multasSelected.length > 0 && (
                <ModalPixDetailContainer>
                  <h2>Multas</h2>
                  {multasSelected.map((multa) => (
                    <ModalPixDetailContainerDebt>
                      <p>
                        {multa.plate} - {multa.uf}
                      </p>
                      <p>
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(multa.value)}
                      </p>
                    </ModalPixDetailContainerDebt>
                  ))}
                </ModalPixDetailContainer>
              )}
              {licenciamentoSelected.length > 0 && (
                <ModalPixDetailContainer>
                  <h2>Licenciamento</h2>
                  {licenciamentoSelected.map((licenciamento) => (
                    <ModalPixDetailContainerDebt>
                      <p>
                        {licenciamento.plate} - {licenciamento.uf}
                      </p>
                      <p>
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(licenciamento.value)}
                      </p>
                    </ModalPixDetailContainerDebt>
                  ))}
                </ModalPixDetailContainer>
              )}
              {outrosSelected.length > 0 && (
                <ModalPixDetailContainer>
                  <h2>Outros</h2>
                  {outrosSelected.map((outro) => (
                    <ModalPixDetailContainerDebt>
                      <p>
                        {outro.plate} - {outro.uf}
                      </p>
                      <p>
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(outro.value)}
                      </p>
                    </ModalPixDetailContainerDebt>
                  ))}
                </ModalPixDetailContainer>
              )}
              <ModalPixButton>
                <button
                  onClick={() => {
                    setShowModalDetail(false);
                  }}
                >
                  Fechar
                  <FiX />
                </button>
              </ModalPixButton>
            </ModalPixDetail>
          </ModalPixContent>
        </ModalPix>
      )}
      {modalPixSuccess && (
        <ModalPix>
          <ModalPixContent>
            <ModalPixIconSuccessMessage>
              <img
                src={'/icons/icon-circle-check-fill.svg'}
                alt="Icone do modal de pix confirmado"
              />
            </ModalPixIconSuccessMessage>
            <ModalPixDetail>
              <ModalPixSuccessMessage>
                <h2>
                  Seu pagamento foi concluído
                  <br /> com sucesso!
                </h2>
              </ModalPixSuccessMessage>
              <ModalPixButton>
                <button
                  onClick={() => {
                    setModalPixSuccess(false);
                    navigate('/');
                  }}
                >
                  Fechar
                  <FiChevronRight />
                </button>
              </ModalPixButton>
            </ModalPixDetail>
          </ModalPixContent>
        </ModalPix>
      )}
      <DefaultContainer>
        <PixPaymentContainer>
          <StyledTitle marginTop={4.5} title=" Pagamento" />
          <DefaultDivPix>
            <DefaultTitlePix>
              Siga as instruções a seguir para efetuar o seu pagamento:
            </DefaultTitlePix>
          </DefaultDivPix>
          <DivList>
            <DefaultSpanListPix>
              1. Acesse a opção PIX no seu Internet Banking ou app de
              pagamentos;
            </DefaultSpanListPix>
            <DefaultSpanListPix>
              2. Escaneie o QR Code a seguir ou copie o código de pagamento;
            </DefaultSpanListPix>
            <DefaultSpanListPix>
              3. Assim que recebermos seu pagamento, você receberá uma
              notificação no e-mail cadastrado.{' '}
            </DefaultSpanListPix>
          </DivList>
          <DivGrid>
            {pixQrCodeBase64 ? (
              <DivPixQrCode>
                {pixQrCodeBase64 && (
                  <img
                    src={`data:image/jpeg;base64,${pixQrCodeBase64}`}
                    alt="Pix Qr Code"
                    width={160}
                    height={160}
                  />
                )}
              </DivPixQrCode>
            ) : (
              <SpanQrCode>Não foi possivel mostrar o QRCode</SpanQrCode>
            )}
            <SpanQrCode>
              Se preferir, copie o código abaixo para realizar o pagamento.
            </SpanQrCode>
          </DivGrid>
          <DivCopyPaste>
            {isPixCopied && (
              <DivPixCodeNotification>
                Pix copiado com sucesso!
              </DivPixCodeNotification>
            )}
            <TextAreaCopyPaste
              name="pixcode"
              defaultValue={pixCopiaCola}
              rows={2}
              readOnly
            ></TextAreaCopyPaste>
            <ButtonCopyPaste
              onClick={(e) => {
                e.preventDefault();
                copyTextToClipboard(pixCopiaCola);
                setIsPixCopied(true);
              }}
            >
              <FiCopy size={16} />
            </ButtonCopyPaste>
          </DivCopyPaste>
          <DivGrid>
            <SpanWaitingPayment color="rgba(66, 66, 66, 1)" weight={300}>
              Estamos verificando seu pagamento, aguarde...{' '}
            </SpanWaitingPayment>
            <SpanWaitingPayment color="rgba(245, 130, 32, 1)" weight={400}>
              Efetue o pagamento em até{' '}
              <SpanWaitingPayment color="rgba(245, 130, 32, 1)" weight={700}>
                30 minutos.
              </SpanWaitingPayment>
            </SpanWaitingPayment>
          </DivGrid>
        </PixPaymentContainer>
        <PaymentSummaryPix>
          <DefaultContainerSummaryPix display={'flex'} marginTop={6}>
            <TitleSummaryPix>Resumo do pedido:</TitleSummaryPix>
          </DefaultContainerSummaryPix>
          <DefaultContainerSummaryPix display={'grid'} marginTop={6}>
            <TextSummaryPix fontSize={14} fontWeight={400}>
              Pix (à vista)
            </TextSummaryPix>
            <TextSummaryPix fontSize={14} fontWeight={600} marginTop={8}>
              Total:{' '}
              {pix?.totalPrice
                ? new Intl.NumberFormat('pt-BR', {
                  currency: 'BRL',
                  style: 'currency',
                }).format(Number(pix?.totalPrice))
                : 'R$ 0,00'}
            </TextSummaryPix>
          </DefaultContainerSummaryPix>
          <DefaultContainerSummaryPix gap={8} display={'flex'} marginTop={4}>
            <TextSummaryPixLink
              color={'rgba(245, 130, 32, 1)'}
              textDecoration={'underline'}
              fontSize={14}
              fontWeight={400}
              onClick={() => setShowModalDetail(true)}
            >
              Detalhe do pedido
            </TextSummaryPixLink>
            <IoIosArrowForward
              style={{ marginTop: '4px', color: 'rgba(245, 130, 32, 1)' }}
            />
          </DefaultContainerSummaryPix>
          <DefaultContainerSummaryPix display={'flex'} marginTop={4}>
            <TextSummaryPix fontSize={14} fontWeight={400}>
              Número do pedido:{' '}
              <TextSummaryPix fontSize={14} fontWeight={600}>
                {/* {consultCode !== 0 ? consultCode : storeData?.consultCode} */}
              </TextSummaryPix>
            </TextSummaryPix>
          </DefaultContainerSummaryPix>
          <DefaultContainerSummaryPix
            display={'flex'}
            marginTop={4}
            marginRight={2}
          >
            <TextSummaryPix fontSize={14} fontWeight={400}>
              O pagamento via PIX é realizado no mesmo dia, junto ao órgão
              emissor, quando é feito até as 17:30h no site da Zignet. Em casos
              de transações realizadas após esse horário, o pagamento é
              realizado no dia útil seguinte. O prazo de baixa dos débitos varia
              de acordo com cada órgão, podendo levar até 5 dias úteis para que
              os débitos sejam baixados no sistema. Em caso de dúvidas, nos
              chame no WhatsApp (11) 94549-1306.
            </TextSummaryPix>
          </DefaultContainerSummaryPix>
          <DefaultContainerSummaryPix
            gap={4}
            display={'flex'}
            marginTop={4}
            justifyContent={'center'}
            marginRight={2}
            onClick={() => navigate('/debts/batch-payment')}
          >
            <IoIosArrowDropleftCircle
              style={{
                marginTop: '3px',
                color: 'rgba(245, 130, 32, 1)',
                fontSize: '16px',
              }}
            />
            <TextSummaryPix
              color={'rgba(245, 130, 32, 1)'}
              textDecoration={'underline'}
              fontSize={14}
              fontWeight={400}
            >
              Voltar
            </TextSummaryPix>
          </DefaultContainerSummaryPix>
        </PaymentSummaryPix>
      </DefaultContainer>
    </>
  );
};

export default PixBatchPayment;
